export default __webpack_public_path__ + "static/outrider-content-sm-a17704a6347cee98ea88a68c163773d6.mp4";